
import { contentInfoType } from 'types';

export const showScores = (
    guest:  boolean,
    update: boolean,
    id:     string,
    hash:   contentInfoType,
) => {

   return !!(!guest && update && hash[id] && hash[id].studentScores && hash[id].studentScores === 1 )
}

export const showDescription = ( val: contentInfoType ) => {
    return !!((val.description && val.description.length) || (val.youtube && val.youtube.length && val.youtube !== 'hide' && val.youtube !== "show"))
}
  